import { render, staticRenderFns } from "./Dienstplan.vue?vue&type=template&id=1378bf65&"
import script from "./Dienstplan.vue?vue&type=script&lang=ts&"
export * from "./Dienstplan.vue?vue&type=script&lang=ts&"
import style0 from "./Dienstplan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports